export const auth = {
  field: {
    email: 'Адрес электронной почты',
    password: 'Пароль',
    remember_me: 'Запомнить'
  },

  button: {
    recovery_password: 'Восстановить пароль',
    create_account: 'Создать аккаунт',
    no_acc: 'Нет учетной записи?',
    sign_up: 'Регистрация',
    sign_in: 'Авторизоваться',
    log_in: 'Войти'
  },

  message:
    'Раздел на сайте обновляется и появится позже. Для регистрации, пожалуйста, обратитесь к нашей команде поддержки',
  phone: 'Телефон'
};
